import React from 'react';

type SupportPageProps = {
  appIconUrl: string;
  appStoreUrl: string;
};

export function SupportPage({appIconUrl, appStoreUrl}: SupportPageProps) {
  return (
    <main className="app">
      <section className="hero support-hero">
        <div className="hero-brand">
          <img className="hero-icon" src={appIconUrl} alt="Dashless app icon" />
          <p className="eyebrow">Dashless Support</p>
        </div>
        <h1 className="title">Support for Dashless iOS</h1>
        <p className="subtitle">
          Need help with setup, compatibility, telemetry, or purchases? Use the
          support options below and we’ll help you get back on the road.
        </p>
      </section>

      <section className="section">
        <h2>Get help</h2>
        <div className="grid">
          <article className="card">
            <h3>Email support</h3>
            <p>
              Contact us at{' '}
              <a href="mailto:support@dashless.autos">support@dashless.autos</a> for
              account, purchase, or troubleshooting help.
            </p>
          </article>
          <article className="card">
            <h3>Include these details</h3>
            <p>
              Device model, iOS version, Dashless app version, OBD2 adapter name,
              and a short description of what happened.
            </p>
          </article>
          <article className="card">
            <h3>Typical response</h3>
            <p>We aim to reply within 1–2 business days.</p>
          </article>
        </div>
      </section>

      <footer className="footer">
        <p>Dashless for iOS</p>
        <div className="footer-links">
          <a href="/">Home</a>
          <a href="/ios-privacy">iOS Privacy Policy</a>
          <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
            App Store
          </a>
        </div>
      </footer>
    </main>
  );
}
